export const publishToSns = (args) => {
  return (dispatch) => {
    fetch("/api/v1/aws/sns/publish", {
      method: "POST",
      body: JSON.stringify(args),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Access-Level": "read-write",
      },
    });
  };
};

export const getIpAndPublishToSns = (args) => {
  return (dispatch) => {
    fetch(`/api/v1/inbio/customers/ip`, { credentials: "same-origin" })
      .then((res) => res.json())
      .then((data) => {
        args.payload.ip = data.ip;
        dispatch(publishToSns(args))
      });
  };
};
